import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {PathService} from "./path.service";
import {Observable} from "rxjs";
import {AnyMap, IdInfo, OkInfo} from "../util/interfaces";
import {map} from "rxjs/operators";

export type PromoType = 'amount_off' | 'percent_off';

export interface Promo {
    id?: number;
    code: string;
    type: PromoType;
    discount: number;
    initial_inventory?: number;
    inventory?: number;
    expires?: string; // timestamp with tz in SQL format
    institutional?: boolean;
    disabled?: boolean;
    expired?: boolean;
    exhausted?: boolean;
    inactive?: boolean;
}

@Injectable({
    providedIn: 'root'
})
export class PromoService {

    readonly promoRoot;

    constructor(private http: HttpClient,
                private pathService: PathService) {
        this.promoRoot = `${this.pathService.apiRoot}/promo`;
    }

    checkAvailable(code: string): Observable<boolean> {
        return this.http.post<OkInfo>(`${this.promoRoot}/check`, {code: code}).pipe(
            map((info) => info.ok)
        );
    }

    getAll(): Observable<Promo[]> {
        return this.http.get<AnyMap>(this.promoRoot).pipe(
            map((info) => info.promos)
        );
    }

    add(promo: Promo): Observable<IdInfo> {
        return this.http.post<IdInfo>(this.promoRoot, promo);
    }

    update(promo: Promo): Observable<OkInfo> {
        return this.http.put<OkInfo>(this.promoRoot, promo);
    }
}
